import { fabric } from 'fabric';
import ToolOption from '../common/ToolOption';
import UndoManager from '../manager/UndoManager';
import { CanvasEventType, GraphType, GraphName } from './../constants/Constants';
import Graphic from './Graphic';

/**
 * 直线类
 *
 * @export
 * @class CanvasLine
 * @extends {Graphic}
 * @author zhenliang.sun
 */
export default class CanvasLine extends Graphic {
  constructor(app) {
    super(app);
    this._shape = null;
    this._isMouseDown = false;
    this.ox = 0;
    this.oy = 0;

    this.e = {
      mouseDown: this._mouseDownHandler.bind(this),
      mouseMove: this._mouseMoveHandler.bind(this),
      mouseUp: this._mouseUpHandler.bind(this)
    };
  }

  get option() {
    return this._option;
  }

  set option(val) {
    super.option = val;

    if (!val) {
      this._option = this.defaultOption();
    }

    Object.assign(this._option, val);
  }

  get defaultOption() {
    return new ToolOption();
  }

  addEvents() {
    super.addEvents();
    this.root.on(CanvasEventType.MouseDown, this.e.mouseDown);

    this.root.on(CanvasEventType.MouseMove, this.e.mouseMove);

    this.root.on(CanvasEventType.MouseUp, this.e.mouseUp);
  }

  removeEvents() {
    super.removeEvents();
    this.root.off(CanvasEventType.MouseDown, this.e.mouseDown);
    this.root.off(CanvasEventType.MouseMove, this.e.mouseMove);
    this.root.off(CanvasEventType.MouseUp, this.e.mouseUp);
  }

  _mouseDownHandler(o) {
    this._isMouseDown = true;
    let sp = this.root.getPointer(o.e);
    this.ox = +sp.x.toFixed(1);
    this.oy = +sp.y.toFixed(1);

    this._shape = new fabric[GraphName.LINE]([this.ox, this.oy, this.ox, this.oy], {
      strokeWidth: this._option.strokeWidth,
      stroke: this._option.stroke,
      selectable: false
    });
    this.root.add(this._shape);
    this.stage.renderNow();
  }
  _mouseMoveHandler(o) {
    if (!this._isMouseDown) {
      return;
    }

    let sp = this.root.getPointer(o.e);
    this._shape.set({
      x2: sp.x,
      y2: sp.y
    });
    this.stage.renderNow();
  }
  _mouseUpHandler(o) {
    this._isMouseDown = false;
    this._shape.setCoords();
    this.stage.renderNow();

    let data = this.factory.createAddData(this._shape);
    this.app.sender.add(data);

    let allData = this.root.toDatalessJSON();
    UndoManager.getInstance().save(allData);
  }

  static toAddData(target) {
    let obj = Graphic.toAddData(target);
    obj.fill = target.fill;
    obj.x1 = target.x1;
    obj.y1 = target.y1;
    obj.x2 = target.x2;
    obj.y2 = target.y2;
    obj.zoomX = target.zoomX;
    obj.zoomY = target.zoomY;
    obj.gtype = GraphType.LINE;
    return obj;
  }
}
